export default function getStringDateAndHourFromDate(parameterDate: Date) {
  const strinDate = parameterDate.toLocaleString()
  const [date, fullHour] = strinDate.split(' ')
  const hour = fullHour.substring(0, 5)
  let newDate = date
  if (date.indexOf(',') !== -1) newDate = date.replace(',', '')
  return { date: newDate, hour }
}
